
import Vue from 'vue';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { mapState } from 'pinia';
import ClosedNotifications from './ClosedNotifications.vue';
import OpenNotifications from './OpenNotifications.vue';

export default Vue.extend({
  name: 'NotificationsManagement',

  components: {
    ClosedNotifications,
    OpenNotifications,
  },

  data() {
    return {
      isNotContainerOpen: false,
    };
  },

  computed: {
    ...mapState(useNotificationStore, [
      'redAndOrangeNotifications',
      'hasRedNotifications',
    ]),

    notificationsNum(): number {
      return (
        this.redAndOrangeNotifications && this.redAndOrangeNotifications.length
      );
    },
  },

  methods: {},
});
